import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_IMAGE_FRAME } from './mobileMotion'

export default function Slide8M() {
  const { t } = useLanguage()
  const s = t.slides.slide8

  return (
    <MobileSlideShell>
      <motion.p
        {...fadeScaleProps(0)}
        className="text-[13px] font-bold uppercase tracking-[0.2em] text-[#1B2A6B]/50"
      >
        {s.eyebrow}
      </motion.p>

      <motion.h2
        {...fadeScaleProps(0.06)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.headline}
      </motion.h2>

      <motion.div {...fadeScaleProps(0.1)} className={M_IMAGE_FRAME}>
        <img
          src="/slides/slide_08.png"
          alt=""
          className="block w-full"
          loading="lazy"
          decoding="async"
        />
      </motion.div>

      <motion.div
        {...fadeScaleProps(0.16)}
        className="rounded-2xl border border-white/40 bg-white/70 p-5 shadow-[0_4px_20px_rgba(0,0,0,0.06)] backdrop-blur-md"
      >
        <p className="text-[16px] leading-relaxed text-[#1B2A6B]/75">
          {s.body}{' '}
          <strong className="font-semibold text-[#1B2A6B]">{s.bodyBold}</strong>{' '}
          {s.body2}
        </p>
      </motion.div>
    </MobileSlideShell>
  )
}
